/** exportStatus関数リクエスト */
export interface ExportStatusParam {
  /** システムID */
  system: string
  /** ジョブID */
  jobId: string
}

/** CSV出力処理状況 定数定義 */
export const ExportProcessState = {
  /** 待機 */
  WAITING: '00',
  /** 処理中 */
  PROCESSING: '10',
  /** 完了 */
  COMPLETED: '20',
  /** エラー */
  ERROR: '99'
} as const

/** CSV出力処理状況 型定義 */
export type ExportProcessState = (typeof ExportProcessState)[keyof typeof ExportProcessState]

/** exportStatus関数レスポンス */
export interface ExportStatusResponse {
  /** 処理状況 */
  processState: ExportProcessState
}
